// extracted by mini-css-extract-plugin
export default {"events":"Events_events__30BqJ","title":"Events_title__JqA03","heading":"Events_heading__Tito3","name":"Events_name__5exru","date":"Events_date__SoPCJ","desc":"Events_desc__-fYM7"};